<template>
  <span
    v-if="!isAction"
  >{{$t(`${list == false ? 'orderDetailsStatuses': 'ordersStatuses'}.${status}`)}}</span>
  <button
    class="order-item__status_button"
    v-else
  >{{$t(`${list == false ? 'orderDetailsStatuses': 'ordersStatuses'}.${status}`)}}</button>
</template>

<script>
export default {
  name: "orders-btn",
  props: {
    status: {
      required: true
    },
    list: {
      required: false,
      default: true
    }
  },
  computed: {
    isAction() {
      return (
        this.status == "job_finished" ||
        this.status == "payment" ||
        this.status == "rating_review"
      );
    }
  }
};
</script>